/*
Copyright © 2021 EPAM Systems, Inc. All Rights Reserved.
All information contained herein is, and remains the property of EPAM Systems, Inc.
and/or its suppliers and is protected by international intellectual property law.
Dissemination of this information or reproduction of this material is strictly
forbidden, unless prior written permission is obtained from EPAM Systems, Inc
*/
import React, { useEffect } from 'react';

export const ClickOutside = ({ children, onClick, open }) => {
    const refs = React.Children.map(children, () => React.createRef());

    const handleClick = (e) => {
        const isOutside = refs.every(ref => !!ref.current && !ref.current.contains(e.target));
        if (isOutside && open) {
            onClick();
        }
    };

    useEffect(() => {
        if (open) {
            // eslint-disable-next-line no-undef
            document.addEventListener('mouseup', handleClick);
        }
        // eslint-disable-next-line no-undef
        return () => document.removeEventListener('mouseup', handleClick);
    });

    return React.Children.map(children, (element, idx) => React.cloneElement(element, { ...element.props, ref: refs[idx] }));
};
